import React from "react"
import { Link } from "react-router-dom"

import UserListItem from "../../../common/UserListItem"
import UserListItemShadow from "../../../common/UserListItemShadow"

const ViewFeedItemCreator = ({ creator, publisher, isFetching }) => {
    let userComponent = null
    if (isFetching) {
        userComponent = <UserListItemShadow />
    } else if (creator) {
        userComponent = (
            <Link to={`/users/${creator.id}`} style={{ textDecoration: "none" }}>
                <UserListItem {...creator} />
            </Link>
        )
    } else {
        userComponent = (
            <p>
                This article was <strong>automatically</strong> scraped from{" "}
                {publisher}.
            </p>
        )
    }
    return (
        <div className="widget">
            <h3 className="widget-header">
                <span className="icon icon-community-people" />
                Submitted by
            </h3>
            <div className="widget-content list-group items-list">
                {userComponent}
            </div>
        </div>
    )
}

export default ViewFeedItemCreator
